export default function ScheduleNavIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <rect x="3" y="4.5" width="16" height="14" rx="2" stroke="#EFE8DE" strokeWidth="1.5" />
      <path d="M3 8.5H19" stroke="#EFE8DE" strokeWidth="1.5" />
      <path d="M7.5 3V6" stroke="#EFE8DE" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M14.5 3V6" stroke="#EFE8DE" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
